import { BarChart3 } from 'lucide-react';
import QrcWorkshop from '../../../components/quiz/QrcWorkshop';

/**
 * Onglet « Rédaction » (mode « Répondre à des questions courtes », décision Fabien du
 * 29/09/2026) : les réponses rédigées ont leur propre entrée dans le dock, au lieu d'un
 * encart dans l'onglet Quiz.
 *
 * L'atelier fait tout : liste des questions par sujet, question active en grand, et
 * pour qui n'a pas le moteur il met en avant la question de démonstration avec ses
 * exemples corrigés. Un bloc de démonstration séparé le précédait ; il montrait la
 * MÊME question avec les MÊMES exemples, soit deux fois la même chose sur une page
 * (retiré le 30/09/2026, décision Fabien).
 */
export default function TabRedaction({
    scope, user, has_access, categories, accentColor = null,
    onLocked = null, onGoToSujet = null, onShowResults = null,
}) {
    const qrcSujets = (categories || []).flatMap(c => (c.sous_sujets || [])
        .filter(ss => Number(ss.qrc_count || 0) > 0 && ss.custom_status !== 'OBSOLETE' && ss.status !== 'OBSOLETE')
        .map(ss => ({ ...ss, matiere_label: c.label })));

    if (!qrcSujets.length) {
        return <p className="sl-redaction-empty">Cette thématique ne propose pas encore de questions à réponse rédigée.</p>;
    }

    return (
        <div className="sl-redaction">
            <QrcWorkshop
                scope={scope} sujets={qrcSujets} user={user} hasAccess={has_access} accentColor={accentColor}
                readOnly={!user} onOpenSujet={onGoToSujet} onSubscribe={onLocked}
            />
            {user && onShowResults && (
                <p className="sl-redaction-hist">
                    <BarChart3 size={14} /> Tes corrections passées sont dans
                    {' '}<button type="button" onClick={onShowResults}>Mes résultats</button>, section « Réponses rédigées ».
                </p>
            )}
        </div>
    );
}
